import { Component, OnInit } from '@angular/core';
import config from '../../../frontend_config.json';

import {LanguageService} from '../language/language.service';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss']
})
export class TermsOfUseComponent implements OnInit {

  config = config

  constructor(
    private meta: Meta,
    private titleService: Title,
    public languageService: LanguageService
  ) { }

  ngOnInit(): void {
  }

}
